import { Context } from 'react'
import { UserContext, userReducer, initUserState } from './userStore'
import { LunwenContext, lunwenReducer, initLunwenState } from './lunwenStore'
import { TemporaryContext, temporaryReducer, initTemporaryState } from './temporaryStore'

export interface ContextConfig<TState> {
  Context: Context<any> // 你可以进一步加强类型，例如 Context<TState & { dispatch: Function }>
  reducer: React.Reducer<TState, any>
  initialState: TState
}

export const contextConfigs: ContextConfig<any>[] = [
  {
    Context: UserContext,
    reducer: userReducer,
    initialState: initUserState
  },
  {
    Context: LunwenContext,
    reducer: lunwenReducer,
    initialState: initLunwenState
  },
  {
    Context: TemporaryContext,
    reducer: temporaryReducer,
    initialState: initTemporaryState
  }
]
